import React from 'react';
import { Autocomplete, Card, Box, Typography, TextField, FormControl, Select, MenuItem } from '@mui/material';
import ChecklistRtlOutlinedIcon from '@mui/icons-material/ChecklistRtlOutlined';

export default function ProductIdentification({ productName, matCode, productOptions = [], onProductChange, productType, setProductType, productTypes = [], component, setComponent, components = [], disabled = false }) {
  const selectedProduct = productOptions.find((option) => (
    String(option.productCode) === String(matCode) && option.label === productName
  )) || null;

  return (
    <Card sx={{ width: '100%', height: '100%', p: { xs: 1.4, md: 1.75 }, borderRadius: 1.4, boxShadow: 'none', border: '1px solid #edf1f1', bgcolor: 'background.paper' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.95 }}>
        <ChecklistRtlOutlinedIcon sx={{ color: '#00B3BD', mr: 0.75, fontSize: 24 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 500, mr: 1, color: '#00B3BD', fontSize: 22 }}>Product Identification</Typography>
      </Box>

      <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Product Name</Typography>

      <Autocomplete
        fullWidth
        options={productOptions}
        value={selectedProduct}
        disabled={disabled}
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event, value) => onProductChange(value)}
        filterOptions={(options, state) => {
          const query = state.inputValue.trim().toLowerCase();
          if (!query) return options;
          return options.filter((option) => (
            String(option.productCode || '').toLowerCase().includes(query)
            || String(option.label || '').toLowerCase().includes(query)
          ));
        }}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            <Box>
              <Typography sx={{ fontSize: 20 }}>{option.label}</Typography>
              <Typography sx={{ fontSize: 16, color: 'text.secondary' }}>{option.productCode}</Typography>
            </Box>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="ค้นหาจากชื่อสินค้าหรือ Mat. Code"
            size="small"
            sx={{ mb: 0.95, '& .MuiInputBase-root': { height: 56, borderRadius: 1.1 }, '& .MuiInputBase-input': { fontSize: 20, py: 0 } }}
          />
        )}
        noOptionsText="ไม่พบสินค้า"
      />

      <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Mat. Code</Typography>

      <TextField
        fullWidth
        placeholder=""
        value={matCode}
        sx={{ mb: 0.95, '& .MuiInputBase-root': { height: 56, borderRadius: 1.1 }, '& .MuiInputBase-input': { fontSize: 20, py: 0 } }}
        size="small"
        InputProps={{ readOnly: true }}
        disabled
        variant="outlined"
        helperText={''}
      />

      <Box sx={{ display: 'flex', gap: 1.4, mt: 0.1 }}>
        <FormControl fullWidth>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Product Type</Typography>
          <Select value={productType} displayEmpty onChange={(e) => setProductType(e.target.value)} disabled={disabled || !matCode} size="small" sx={{ height: 56, borderRadius: 1.1, '& .MuiSelect-select': { height: '56px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', py: 0, fontSize: 20 } }}>
            <MenuItem value="">-</MenuItem>
            {productTypes.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Components</Typography>
          <Select value={component} displayEmpty onChange={(e) => setComponent(e.target.value)} disabled={disabled || !productType} size="small" sx={{ height: 56, borderRadius: 1.1, '& .MuiSelect-select': { height: '56px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', py: 0, fontSize: 20 } }}>
            <MenuItem value="">-</MenuItem>
            {components.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>
    </Card>
  );
}

